import { Badge } from "@/components/ui/badge";
import { getStatusLabel, getStatusVariant, type StatusVariant } from "@/lib/status-machine";
import { cn } from "@/lib/utils";
import type { ObjectiveStatus, KrStatus } from "@/types/entities";

type Status = ObjectiveStatus | KrStatus;

interface StatusBadgeProps {
  status: Status;
}

const DOT_CLASS: Partial<Record<StatusVariant, string>> = {
  "status-draft":       "bg-[hsl(var(--status-draft-text))]",
  "status-approved":    "bg-[hsl(var(--status-approved-text))]",
  "status-inprogress":  "bg-[hsl(var(--status-inprogress-text))]",
  accent:               "bg-[hsl(var(--accent-foreground))]",
  destructive:          "bg-[hsl(var(--destructive-foreground))]",
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const variant = getStatusVariant(status);
  const dotClass = DOT_CLASS[variant];

  return (
    <Badge variant={variant}>
      {dotClass && (
        <span className={cn("mr-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full", dotClass)} />
      )}
      {getStatusLabel(status)}
    </Badge>
  );
}
